// A tiny framework-free typed event emitter. The core surfaces its
// sync-status / notice / attachment-state changes through these so the
// Obsidian adapter and web viewer can subscribe without importing any UI
// framework (plugin spec §Core engine: "clean event/state surface").

export type Listener<T> = (value: T) => void;

/** One event channel carrying values of type `T`. */
export class Emitter<T> {
  private readonly listeners = new Set<Listener<T>>();

  /** Subscribe; returns an unsubscribe function. */
  on(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  /** Emit a value to every current listener. */
  emit(value: T): void {
    for (const listener of [...this.listeners]) {
      listener(value);
    }
  }

  /** Number of active listeners (used only in tests). */
  get size(): number {
    return this.listeners.size;
  }
}
